function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 9");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "album",
  transform: "translate(-3.000000, 0.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-9",
  transform: "translate(3.000000, 0.000000)"
}, React.createElement("path", {
  d: "M5.41992181e-06,23.9967076 C3.72333531e-05,23.9870449 9.88677889e-05,23.9773891 0.000190230501,23.9677403 L0.0118563258,3.74287276 C-0.00416759188,1.71299536 1.51316233,0.0170947769 3.45872561,-2.80664381e-13 L22.0004199,-2.80664381e-13 L21.9886647,27.9998001 L20.9890845,27.9998001 L3.51013856,27.9997129 C1.57243338,28.0253094 0.0234991145,26.3623609 -6.37712105e-13,24.3198207 L1.65354756e-07,24.2972458 L0.000173521294,23.9967082 Z M19.9920231,20 L19.9995801,1.99996123 L3.50875517,2 L3.46753174,1.99996123 C2.67894375,2.00690591 2.00416845,2.76109378 2.011825,3.73555405 L2.002255,20.3766451 C2.4497044,20.1355172 2.95215023,20 3.48828214,20 L19.9920231,20 Z M19.9911834,22 L3.48828214,22 C2.72135408,22 2.01393707,22.846182 2.00018346,23.9788091 L2,24.2978209 L1.99993345,24.3082841 C2.01107547,25.2740118 2.6968654,26.0102815 3.49693,25.9998001 L19.9895042,25.9998001 L19.9911834,22 Z",
  id: "Combined-Shape"
}), React.createElement("path", {
  d: "M7,12 L16,12 L16,6 L7,6 L7,12 Z M16,14 L7,14 L7,16 L16,16 L16,14 Z M5,18 L5,4 L18,4 L18,18 L5,18 Z",
  id: "Combined-Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/album.65d8935f.svg";
export { SvgComponent as ReactComponent };